<template>
  <div>
    <!-- 发票配置 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>发票配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="elCard">
      <div class="elCardDiv">
        <el-form ref="form" :model="form" label-width="130px" :rules="rule" >
          <el-form-item label="发票公司名称:" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="税号:" prop="duty">
            <el-input v-model="form.duty"></el-input>
          </el-form-item>
          <el-form-item label="地址:" prop="site">
            <el-input v-model="form.site"></el-input>
          </el-form-item>
          <el-form-item label="电话:" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="开户行:" prop="bink_site">
            <el-input v-model="form.bink_site"></el-input>
          </el-form-item>
          <el-form-item label="账号:" prop="account">
            <el-input v-model="form.account"></el-input>
          </el-form-item>
          <el-form-item label="收件人:" prop="username">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item label="邮寄地址:" prop="address">
            <el-input v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话:" prop="expressphone">
            <el-input v-model="form.expressphone"></el-input>
          </el-form-item>
          <el-form-item class="itemBtn" >
            <el-button @click="itemBtns('form')">保存配置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import {invoiceConfig,invoiceConfigInfo} from '@/request/distributor.js'
export default {
  data() {
    return {
      form: {
        token:window.sessionStorage.getItem('Token'),
        name: "", //发票公司名称：
        duty:"",  //税号：
        site:"",  //地址：
        phone:"",    //电话：
        bink_site:"", //开户行：
        account:"" , //账号：
        username:"",  //收件人：
        address:""  ,  //邮寄地址：
        expressphone:"", //收件人电话：
      },
      rule:{
        name: [
            { required: true, message: '请输入发票公司名称', trigger: 'blur' },
        ],
        duty: [
            { required: true, message: '请输入税号', trigger: 'blur' },
        ],
        site: [
            { required: true, message: '请输入地址', trigger: 'blur' },
        ],
        phone: [
            { required: true, message: '请输入电话', trigger: 'blur' },
        ],
        bink_site: [
            { required: true, message: '请输入开户行', trigger: 'blur' },
        ],
        account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
        ],
        username: [
            { required: true, message: '请输入收件人', trigger: 'blur' },
        ],
        address: [
            { required: true, message: '请输入邮寄地址', trigger: 'blur' },
        ],
        expressphone: [
            { required: true, message: '请输入收件人电话', trigger: 'blur' },
        ],
      }
    };
  },
  created(){
    this.getDetail()
  },
  methods:{
    getDetail(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      invoiceConfigInfo(data).then(res=>{
        console.log(res.data.result)
        if(res.data.status=='ok'){
          this.form.name=res.data.result.name//发票公司名称：
          this.form.duty=res.data.result.duty //税号：
          this.form.site=res.data.result.site//地址：
          this.form.phone=res.data.result.phone  //电话：
          this.form.bink_site=res.data.result.bink_site//开户行：
          this.form.account=res.data.result.account //账号：
          this.form.username=res.data.result.username //收件人：
          this.form.address=res.data.result.address  //邮寄地址：
          this.form.expressphone=res.data.result.expressphone //收件人电话：
        }
      })
    },
    itemBtns(refs){
      console.log(1)
      this.$refs[refs].validate((valid) => {
          if (valid) {
            invoiceConfig(this.form).then(res=>{
              if(res.data.status=='ok'){
                this.$message.success('保存成功')
                this.getDetail()
              }else{
                this.$message.error(res.data.msg);
              }
            })
          } else {
            return false;
          }
        });
    }
  }
};
</script>

<style lang='less' scope>
.elCard {
  width: 100%;
  height: 800px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.elCardDiv {
  // width: 700px;
  // height: 520px;
  // background: red;
  .el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-input__inner {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  .el-input {
    width: 600px;
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 70px;
    .el-button {
      width: 100px;
      background: #006afa;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
      margin-left: -130px;
    }
  }
}
</style>